module.exports = __webpack_public_path__ + "static/media/5.764ff046.jpg";